import AmplitudeService from './analytics-amplitude';

class Analytics {
  constructor() {
    this.analytics = new AmplitudeService();
  }

  track = (event, params) => {
    this.analytics.track(event, params);
  };

  topBarLogoutButtonClick = () => {
    this.track('頂欄_帳號_登出帳號_click');
  };

  licensePlatesPageView = () => {
    this.track('車牌頁_pageview');
  };

  licensePlatesCreateLicensePlateButtonClick = () => {
    this.track('車牌頁_新增車牌_click');
  };

  licensePlatesCreateLicensePlateCancelClick = () => {
    this.track('車牌頁_新增車牌_取消_click');
  };

  licensePlatesCreateLicenseNextStepClick = () => {
    this.track('車牌頁_新增車牌_下一步_click');
  };

  licensePlatesCreateTaxSettingSelect = ({ option }) => {
    this.track('車牌頁_新增車牌_發票歸帳設定_select', {
      option,
    });
  };

  licensePlatesEditTaxSettingSelect = ({ option }) => {
    this.track('車牌頁_編輯車牌_發票歸帳設定_select', {
      option,
    });
  };

  licensePlatesCreateTaxSettingEmptyAlert = () => {
    this.track('車牌頁_新增車牌_未填發票歸帳設定_alert');
  };

  licensePlatesEditTaxSettingEmptyAlert = () => {
    this.track('車牌頁_編輯車牌_未填發票歸帳設定_alert');
  };

  licensePlatesCreateConfirmClick = () => {
    this.track('車牌頁_新增車牌_確認新增車牌_click');
  };

  licensePlatesCreateLicensePlateSaveClick = () => {
    this.track('車牌頁_新增車牌_儲存_click');
  };

  licensePlatesDownloadButtonClick = () => {
    this.track('車牌頁_下載車牌_click');
  };

  licensePlatesEditPlateButtonClick = ({ plateNumber }) => {
    this.track('車牌頁_編輯車牌_click', { value: plateNumber });
  };

  licensePlatesEditPlateInfoButtonClick = ({ plateNumber }) => {
    this.track('車牌頁_編輯車牌_編輯車牌資料_click', { value: plateNumber });
  };

  licensePlatesEditPlateInfoConfirmButtonClick = () => {
    this.track('車牌頁_編輯車牌_編輯車牌資料_確認_click');
  };

  licensePlatesEditTaxSettingButtonClick = ({ plateNumber }) => {
    this.track('車牌頁_編輯車牌_編輯發票歸帳設定_click', { value: plateNumber });
  };

  licensePlatesEditTaxSettingButtonConfirmClick = () => {
    this.track('車牌頁_編輯車牌_編輯發票歸帳設定_確認_click');
  };

  licensePlatesFilterParkingBindingStateSelect = ({ state }) => {
    this.track('車牌頁_篩選選項-停車綁定狀態_select', {
      option: state,
    });
  };

  licensePlatesFilterTaxIdNumberSelect = ({ state }) => {
    this.track('車牌頁_篩選選項-歸帳設定_select', {
      option: state,
    });
  };

  licensePlatesFilterParkingBindingStateRemove = () => {
    this.track('車牌頁_清除篩選-停車綁定狀態_click');
  };

  licensePlatesFilterTaxIdNumberRemove = () => {
    this.track('車牌頁_清除篩選-歸帳設定_click');
  };

  licensePlatesParkingBindingFailedHintButtonClick = () => {
    this.track('車牌頁_停車綁定失敗提示按鈕_click');
  };

  licensePlatesRemovePlateButtonClick = () => {
    this.track('車牌頁_移除車牌_clicK');
  };

  licensePlatesRemovePlateCancelClick = () => {
    this.track('車牌頁_移除車牌_取消_click');
  };

  licensePlatesRemovePlateConfirmClick = () => {
    this.track('車牌頁_移除車牌_移除_click');
  };

  licensePlatesUpdatePlateCancelClick = () => {
    this.track('車牌頁_修改車牌_取消_click');
  };

  licensePlatesUpdatePlateSaveClick = () => {
    this.track('車牌頁_修改車牌_儲存_click');
  };

  licensePlatesParkingBindingFailedHintButtonClick = () => {
    this.track('車牌頁_停車綁定失敗提示按鈕_click');
  };

  driversPagePageview = () => {
    this.track('駕駛帳號頁_pageview');
  };

  driverPageSearchButtonClick = () => {
    this.track('駕駛帳號頁_搜尋按鈕_click');
  };

  driverPageCreateDriverAccountButtonClick = () => {
    this.track('駕駛帳號頁_新增駕駛帳號_click');
  };

  driverPageCreateDriverAccountCancelClick = () => {
    this.track('駕駛帳號頁_新增駕駛帳號_取消_click');
  };

  driverPageCreateDriverAccountSaveClick = () => {
    this.track('駕駛帳號頁_新增駕駛帳號_儲存_click');
  };

  driverPageDriverAccountDeleteToggleClick = () => {
    this.track('駕駛帳號頁_駕駛帳號_移除_click');
  };

  driverPageDriverAccountConfirmDialogPageView = () => {
    this.track('駕駛帳號頁_駕駛帳號_確認移除dialog_pageview');
  };

  driverPageDriverAccountConfirmDialogCancelClick = () => {
    this.track('駕駛帳號頁_駕駛帳號_確認移除dialog_取消_click');
  };

  driverPageDriverAccountConfirmDialogConfirmDeleteClick = () => {
    this.track('駕駛帳號頁_駕駛帳號_確認移除dialog_確認移除_click');
  };

  statsPageView = () => {
    this.track('消費統計頁_pageview');
  };

  couponPageView = () => {
    this.track('企業優惠頁_pageview');
  };

  couponPageValidTabClick = () => {
    this.track('企業優惠頁_可使用_click');
  };

  couponPageInvalidTabClick = () => {
    this.track('企業優惠頁_已用畢或過期_click');
  };

  couponPagePromotionDetailClick = ({ isOpen }) => {
    this.track('企業優惠頁_展開優惠說明_click', {
      動作: isOpen ? '展開' : '收起',
    });
  };
}

export default new Analytics();
